import { render, staticRenderFns } from "./BDdyTable.vue?vue&type=template&id=23eaf59c&scoped=true"
import script from "./BDdyTable.vue?vue&type=script&lang=js"
export * from "./BDdyTable.vue?vue&type=script&lang=js"
import style0 from "./BDdyTable.vue?vue&type=style&index=0&id=23eaf59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eaf59c",
  null
  
)

export default component.exports